import { Button, Icon } from '@chakra-ui/react';
import Modal from './Modal';
import { GoAlert } from 'react-icons/go';
import PropTypes from 'prop-types';

const ConfirmDialog = ({
  title,
  message,
  primaryButtonText,
  isOpen,
  onClose,
  onConfirm,
  isProcessing,
  colorScheme,
}) => {
  const config = {
    header: title,
    primaryAction: {
      name: primaryButtonText || 'Aceptar',
      action: onConfirm,
      noClose: true,
      isLoading: isProcessing && isOpen,
    },
    secundaryAction: {
      name: 'Cancelar',
      action: onClose,
      isLoading: isProcessing && isOpen,
    },
    colorScheme,
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => !isProcessing && onClose()}
      size="sm"
    >
      <div className="flex flex-col items-center gap-3 text-center">
        <Icon as={GoAlert} w={50} h={50} color={`${colorScheme}.500` || 'yellow.500'} />
        <span className="text-base">{message}</span>

        <div className="flex gap-4 items-center mt-5">
          <Button
            colorScheme={colorScheme || 'blue'}
            onClick={config.secundaryAction.action}
            isLoading={config.secundaryAction.isLoading}
          >
            {config.secundaryAction.name}
          </Button>

          <Button
            colorScheme={colorScheme || 'blue'}
            onClick={config.primaryAction.action}
            isLoading={config.primaryAction.isLoading}
            variant="outline"
          >
            {config.primaryAction.name}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  primaryButtonText: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool,
  colorScheme: PropTypes.string,
};

export default ConfirmDialog;
